import React from "react";

const News = () => {
   return(<h1>This is News</h1>);
};
export default News;